import React from 'react';
import ComponentDetailPane from '../../components/discovery/ComponentDetailPane';
import {
  ESC_LINE,
  ESC_SUPPLIERS,
  GROUND_STATION,
  GROUND_STATION_LINE,
  LIPO_30C,
  LIPO_40C,
  LIPO_LINE,
  LIPO_LINE_40C,
} from './discoveryAlternativeFixtures';

/**
 * The spec-chip states of one discovery line side by side, each a detail pane
 * on its own: RFQ-134's LiPo as asked (30C), previewing 40C, and after the
 * switch; a line with no other spec (no chips); and RFQ-135's one shop with
 * two products.
 */

/** A detail pane framed like the real one. */
const StaticPane: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div>
    <p className="m-0 mb-s2 text-table-header uppercase text-ink-muted">{title}</p>
    <div className="flex h-[620px] flex-col overflow-hidden rounded-card border border-line bg-surface">{children}</div>
  </div>
);

const noop = () => undefined;

const DiscoverySpecStates: React.FC = () => (
  <div className="grid grid-cols-1 gap-s5 xl:grid-cols-3">
    <StaticPane title="LiPo 30C — default view">
      <ComponentDetailPane {...LIPO_LINE} phase="ready" suppliers={LIPO_30C} tickedKeys={[]} onToggleListing={noop} onUseAlternative={noop} onRetry={noop} isRetrying={false} />
    </StaticPane>
    <StaticPane title="LiPo 30C — previewing 40C">
      <ComponentDetailPane {...LIPO_LINE} phase="ready" suppliers={LIPO_30C} initialSpecGroup="dischargeRate=40C" tickedKeys={[]} onToggleListing={noop} onUseAlternative={noop} onRetry={noop} isRetrying={false} />
    </StaticPane>
    <StaticPane title="LiPo — after switching to 40C">
      <ComponentDetailPane {...LIPO_LINE_40C} phase="ready" suppliers={LIPO_40C} tickedKeys={['l_rc40']} onToggleListing={noop} onUseAlternative={noop} onRetry={noop} isRetrying={false} />
    </StaticPane>
    <StaticPane title="No other spec — no chips">
      <ComponentDetailPane {...ESC_LINE} phase="ready" suppliers={ESC_SUPPLIERS} tickedKeys={['esc-robu']} onToggleListing={noop} onRetry={noop} isRetrying={false} />
    </StaticPane>
    <StaticPane title="One shop, two products (Meridian)">
      <ComponentDetailPane {...GROUND_STATION_LINE} phase="ready" suppliers={GROUND_STATION} tickedKeys={['mt-h7']} onToggleListing={noop} onRetry={noop} isRetrying={false} />
    </StaticPane>
  </div>
);

export default DiscoverySpecStates;
